import { LoadingButton } from "@mui/lab";
import {
  Alert,
  Box,
  Button,
  Grid,
  TextField,
  useMediaQuery,
} from "@mui/material";
import { useFormik } from "formik";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  createMachineUserThunk,
  updateMachineThunk,
} from "store/reducers/vending";
import * as yup from "yup";

const validation = yup.object({
  username: yup.string("Enter username").required("Username required"),
  password: yup.string("Enter password").required("Password required"),
  passwordConfirmation: yup
    .string("Repeat password")
    .oneOf([yup.ref("password"), null], "Passwords must match"),
});

const CreateMachineUserForm = ({ handleNext, handleSkip }) => {
  const isFullWidth = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const vendingState = useSelector((state) => state.vending);
  const dispatch = useDispatch();
  const formik = useFormik({
    initialValues: {
      username: "",
      password: "",
      passwordConfirmation: "",
    },
    validationSchema: validation,
    onSubmit: (data) => {
      console.log(data);
      dispatch(createMachineUserThunk(data));
    },
  });

  useEffect(() => {
    if (vendingState.successMachineUserCreate) {
      if (Boolean(vendingState.currentMachine)) {
        const vm_id = vendingState.currentMachine.id;
        const data = { user: vendingState.createdMachineUser.id };
        dispatch(updateMachineThunk({ id: vm_id, data: data }));
      }
    }
  }, [vendingState.successMachineUserCreate]);

  useEffect(() => {
    if (vendingState.updateMachineSuccess) {
      handleNext();
    }
  }, [vendingState.updateMachineSuccess]);

  useEffect(() => {
    console.log(vendingState.errorMessageMachineUserCreate);
    if (vendingState.errorMessageMachineUserCreate) {
      Object.keys(vendingState.errorMessageMachineUserCreate).forEach((key) => {
        console.log(key, vendingState.errorMessageMachineUserCreate[key][0]);
        formik.setFieldError(
          key,
          vendingState.errorMessageMachineUserCreate[key][0]
        );
      });
    }
  }, [vendingState.errorMessageMachineUserCreate]);

  return (
    <Box sx={{ mb: 2 }}>
      <form onSubmit={formik.handleSubmit}>
        <Grid container columnSpacing={2} rowSpacing={0}>
          <Grid item xs={12} md={6} lg={4}>
            <Box display="flex" flexDirection="column">
              <TextField
                label="Username"
                variant="outlined"
                name="username"
                fullWidth
                sx={{ mt: 3 }}
                value={formik.values.username}
                onChange={formik.handleChange}
                error={Boolean(formik.errors.username)}
                helperText={formik.errors.username}
                autoComplete="new-password"
                required
              />
              <TextField
                label="Password"
                variant="outlined"
                name="password"
                type="password"
                autoComplete="new-password"
                fullWidth
                sx={{ mt: 3 }}
                value={formik.values.password}
                onChange={formik.handleChange}
                error={Boolean(formik.errors.password)}
                helperText={formik.errors.password}
                required
              />
              <TextField
                label="Repeat password"
                variant="outlined"
                name="passwordConfirmation"
                type="password"
                autoComplete="new-password"
                fullWidth
                sx={{ mt: 3 }}
                value={formik.values.passwordConfirmation}
                onChange={formik.handleChange}
                error={Boolean(formik.errors.passwordConfirmation)}
                helperText={formik.errors.passwordConfirmation}
                required
              />
            </Box>
            {(vendingState.errorMachineUserCreate ||
              vendingState.updateMachineError) && (
              <Alert sx={{ mt: 3 }} severity="error">
                Error occurred
              </Alert>
            )}
            {vendingState.updateMachineSuccess && (
              <Alert sx={{ mt: 3 }} severity="success">
                Success
              </Alert>
            )}
            <Box
              sx={{
                display: "flex",
                flexDirection: "row-reverse",
                alignItems: "center",
                marginTop: 3,
              }}
            >
              <LoadingButton
                loading={
                  vendingState.loadingMachineUserCreate ||
                  vendingState.updateMachineLoading
                }
                variant="contained"
                fullWidth={isFullWidth}
                type="submit"
              >
                Continue
              </LoadingButton>
              <Button color="inherit" onClick={handleSkip} sx={{ mr: 1 }}>
                Skip
              </Button>
            </Box>
          </Grid>
        </Grid>
      </form>
    </Box>
  );
};

export default CreateMachineUserForm;
